import { Vue, Prop, Component } from "vue-property-decorator";
import Case from './case.model';

@Component
export default class Event extends Vue {
    @Prop() id!: string;
    @Prop() type!: string;
    @Prop() status!: string;
    @Prop() description!: string;
    @Prop() changed!: boolean;
    @Prop() isWeekend!: boolean;
    @Prop() assignmentId!: string;
    @Prop() needId!: string;
    @Prop() requestId!: string;
    @Prop() requestShiftId!: number;
    @Prop() dailyEvents!: number;    
    @Prop() facilityId!: number;
    @Prop() coid!: string;
    @Prop() facilityName!: string;
    @Prop() facilityCoId!: string;
    @Prop() departmentId!: number;
    @Prop() departmentName!: string;
    @Prop() departmentCode!: string;
    @Prop() departmentShiftId!: number;
    @Prop() shiftCode!: string;
    @Prop() shiftDescription!: string;
    @Prop() skillId!: number;
    @Prop() skill!: string;
    @Prop() productiveTypeId!: number;
    @Prop() productiveType!: string;
    @Prop() date!: Date;
    @Prop() startTime!: Date;
    @Prop() endTime!: Date;
    @Prop() actualStartTime!: Date;
    @Prop() actualEndTime!: Date;
    @Prop() hours!: number;
    @Prop() minutes!: number;
    @Prop() comment!: string;
    @Prop() cases!: Case[];
    @Prop() isCommitment!: boolean;
    @Prop() isSelfScheduled!: boolean;
    @Prop() isOvertime!: boolean;
    @Prop() premiumLaborLevel!: boolean;
    @Prop() dailyEventsType!: string[];  
}